<footer class="row ba-form-button-row">
  <div class="col ba-action-secondary">
    @if (!btnLeftHidden) {
      <button type="button" class="{{btnLeftClass}} {{ btnLeftIconClass }}" (click)="clickLeftEvent()"
        data-analytics-track="true"
        data-analytics-category="Secondary Button"
        data-analytics-action="Klick"
        [dataAnalyticsName]="dataAnalyticsNameLeft"
        data-analytics-value=""
        data-testid="btnZurueckLeiste"
        [disabled]="btnLeftDisabled" [id]="btnLeftId">
        {{ btnLeftLabel }}
      </button>
    }
  </div>
  <div class="col ba-action-primary">
    @if (!btnRightHidden) {
      <button type="button" class="{{btnRightClass}} {{ btnRightIconClass }}" (click)="clickRightEvent()"
        data-analytics-track="true"
        data-analytics-category="Primary Button"
        data-analytics-action="Klick"
        [dataAnalyticsName]="dataAnalyticsNameRight"
        data-analytics-value=""
        data-testid="btnWeiterLeiste"
        [disabled]="btnRightDisabled" [id]="btnRightId">
        {{ btnRightLabel }}
      </button>
    }
  </div>
</footer>
